/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import VideoIcon from "@mui/icons-material/VideoLibrary";
import {
  Delete,
  EditNoteOutlined,
  MoreVertOutlined,
} from "@mui/icons-material";
import EditLessonModal from "./EditLessonModal";

interface Lesson {
  // lesson_id: number;
  title: string;
  duration: string;
  video_type: string;
  video_url: string;
  lesson_type: string;
  attachment_url: string;
  attachment_type: string;
}

interface LessonComponentProps {
  lesson: Lesson;

  handleDeleteLesson: () => void;
  handleEditLesson: (formData: any) => void;
  data: any;
}

const EditLesson: React.FC<LessonComponentProps> = ({
  lesson,

  handleDeleteLesson,
  handleEditLesson,
  data,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleEditClick = () => {
    setModalOpen(true);
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <li onMouseOver={() => setOpen(true)} onMouseOut={() => setOpen(false)}>
      <div className="w-full  flex flex-row items-center justify-between mt-3">
        <div className="flex items-center justify-between">
          <VideoIcon
            style={{
              marginRight: "8px",
              fontSize: 20,
              color: "#00A99D",
            }}
          />
          <h2 className="text-base capitalize">{lesson.title}</h2>
        </div>

        <Tooltip title="Actions">
          <IconButton
            size="small"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <MoreVertOutlined style={{ fontSize: "20px", color: "#00A99D" }} />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          PaperProps={{
            elevation: 4,
            sx: {
              borderRadius: 5,

              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <div className="flex flex-col gap-2 items-center justify-center">
            <IconButton
              onClick={handleDeleteLesson}
              sx={{
                backgroundColor: "transparent",
                "&:hover": { backgroundColor: "#FED7D7" },
              }}
            >
              <Delete fontSize="small" sx={{ color: "#E53E3E" }} />
            </IconButton>
            <IconButton
              onClick={handleEditClick}
              sx={{
                backgroundColor: "transparent",
                "&:hover": { backgroundColor: "#D1FAE5" },
              }}
            >
              <EditNoteOutlined fontSize="small" sx={{ color: "#10B981" }} />
            </IconButton>
          </div>
        </Menu>
      </div>
      <EditLessonModal
        isOpen={modalOpen}
        onClose={handleCloseModal}
        lesson={lesson}
        data={data}
        handleEditLesson={(formData: any) => handleEditLesson(formData)}
      />
    </li>
  );
};

export default EditLesson;
